const _ = require('lodash');

function hasAttribute(configure, alias) {
  return _.filter(configure.run('getAttributes'), { alias }).length > 0;
}

function getPersonalizationStyle(configure, absoluteParent) {
  const alias = absoluteParent + '_customization_selection';
  if (hasAttribute(configure, alias)) {
    const ca = configure.run('getAttribute', { alias });
    const selected = _.find(ca.values, function (o) { return o.selected === true; });
    return selected;
  } else {
    return false;
  }
}

function getFontColor(configure, absoluteParent) {
  const alias = absoluteParent + '_monogram_embroidery_color';
  const col = configure.run('getAttribute', { alias }),
    selected = _.find(col.values, function (o) { return o.selected === true; });
  return selected.color;
}

function getInitials(configure, absoluteParent, lineNum) {
  const alias = absoluteParent + '_monogram' + (lineNum ? lineNum : '');
  if (hasAttribute(configure, alias)) {
    return configure.run('getAttribute', { alias }).value.text;
  }
}

// Since we are creating our UGC image and uploading it manually we need to
// clear the other monogram locations as they are changed.
function clearMonogram(configure, ugcAlias) {
  const changes = [];
  changes.push({ 'ca': { 'alias': ugcAlias }, 'av': { 'clipArt': '' } });
  if (hasAttribute(configure, ugcAlias)) {
    configure.run('setRecipe', changes, function (err) {
      if (err) { throw err; }
    });
  }
}

function updateView(app, alias) {
  let view = alias;

  if (app.helpers.hasAttribute(alias)) {
    view = app.configure.run('getAttribute', { alias }).viewName;
  }

  app.actions.updateView(view);
}

function getCurrentMonogramType(configure, absoluteParent) {
  const col = configure.run('getAttribute', { alias: absoluteParent.alias }),
    selected = _.find(col.values, function (o) { return o.selected === true; });
  return selected;
}

function getAbsoluteParent(configure, id) {
  const result = configure.run('getAttribute', { id });
  if (!result.parentId) {
    return result;
  } else {
    return getAbsoluteParent(configure, result.parentId);
  }
}

module.exports = {
  getAbsoluteParent,
  getCurrentMonogramType,
  updateView,
  clearMonogram,
  getInitials,
  getFontColor,
  getPersonalizationStyle
};
